import React, { useEffect, useState } from 'react'
import { Button, Col, Dropdown, Form, Modal, Row } from 'react-bootstrap'
import search from "../../assets/search.svg";
import '../auth/element.css';
import { callApi } from '../utills/api';
import { showAlert, showError, showSuccess } from '../utills/sweetAlert';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { faFile, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';
import TopNavBar from '../Layout/TopNavBar';
import { Hourglass } from 'react-loader-spinner';

const { RangePicker } = DatePicker;

interface Vendor {
    id: number;
    site_name: string;
    location: string;
    create_date: string;
}

const SubCategory: React.FC = () => {
    const [siteModal, setSiteShow] = useState(false);
    const [siteDetails, setSiteDetails] = useState<any[]>([]);
    const siteShow = () => setSiteShow(true);
    const siteClose = () => {
        setState((prevState) => ({
            ...prevState,
            CatId: "",
            MasterId: "",
            SubcategoryName: "",
        }));
        setSiteShow(false);
    }
  const [loading, setLoading] = useState(false);


    const [state, setState] = useState({
        CatId: "",
        MasterId: "",
        SubcategoryName: "",
        MasterOptionselect: [],

    });

    const siteOnchange = (event: any) => {
        const { name, value } = event.target;
        const sanitizedValue = value.replace(/ {2,}/g, ' ');

        setState((prevState) => ({
            ...prevState,
            [name]: sanitizedValue,
        }));
    }

    const handleSubmit = (event: any) => {
        const form = event.target.form;
        if (form.checkValidity() === false) {
            console.log("Form validation failed.");
            return;
        }
        event.preventDefault();

        const trimmedMasterId = state.MasterId.trim();
        const trimmedSubcategoryName = state.SubcategoryName.trim();

        if (trimmedMasterId && trimmedSubcategoryName) {
            let request = {
                masterId: trimmedMasterId,
                categoryName: trimmedSubcategoryName
            }
            console.log("request-->", request);

            callApi("POST", "subCategoryInsert.php", request)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        showSuccess("Success!", "Sub-Category Created Successfully!");
                        setState((prevState) => ({
                            ...prevState,
                            CatId: "",
                            MasterId: "",
                            SubcategoryName: "",
                        }));
                        setSiteShow(false);
                        tableCategoryShow();
                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        } else {
            showError(
                "Failed", "Empty Space Not Allowed");
        }
    }

    useEffect(() => {
        tableCategoryShow();
        getMasterselect();
    }, []);

    const getMasterselect = () => {
        callApi("GET", "masterDropdown.php", "")
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    console.log("response.data--->", response.data);
                    setState((prevState) => ({
                        ...prevState,
                        MasterOptionselect: response.data
                    }));
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const tableCategoryShow = () => {
        callApi("GET", "subCategorySelect.php", "")
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    console.log("response--->", response.data);
                    setSiteDetails(response.data);
                    console.log("siteDetails--->", siteDetails);
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }


    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = (term: string) => {
        setSearchTerm(term);
    };

    const filteredData = siteDetails.filter((item: any) =>
        Object.values(item).some((value) =>
            (value as string).toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Calculate pagination for filtered data
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;
    const currentData = filteredData.slice(offset, offset + itemsPerPage);
    const handlePageClick = (event: { selected: number }) => {
        setCurrentPage(event.selected);
    };

    // Calculate the display range for the items
    const startItem = offset + 1;
    const endItem = Math.min(offset + itemsPerPage, filteredData.length);


    const handleEdit = (id: any) => {
        let req = {
            categoryId: id,
        };
        callApi("POST", "subCategorySingleSelect.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    setState((prevState) => ({
                        ...prevState,
                        SubcategoryName: response.data[0].subName,
                        MasterId: response.data[0].masterId,
                        CatId: response.data[0].id,
                    }));
                    setSiteShow(true)
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const handleUpdate = (event: any) => {
        const form = event.target.form;
        event.preventDefault();
        let req = {
            categoryId: state.CatId,
            masterId: state.MasterId,
            categoryName: state.SubcategoryName
        };

        callApi("POST", "subCategoryUpdate.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    showSuccess("Success!", "Sub-category Updated Successfully!");
                    setState((prevState) => ({
                        ...prevState,
                        CatId: "",
                        MasterId: "",
                        SubcategoryName: "",
                    }));
                    setSiteShow(false)
                    tableCategoryShow();
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const handleInactive = async (id: any, status: any) => {

        const action = status === "Active" ? "Inactivate" : "Activate";
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to ${action}?`,
            "Yes",
            "No"
        );

        console.log("id-->",id);
        if (isComfirm) {
        const activeInactiveStatus = status === "Active" ? "Inactive" : "Active";
        let req = {
            categoryId: id,
            status: activeInactiveStatus,
        };
        callApi("POST", "subCategoryStatusChange.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    tableCategoryShow();

                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }
    }

    const deleteApi = async (id: any,masterId:any) => {
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to Delete ?`,
            "Yes",
            "No"
        );
        if (isComfirm) {
            let req = {
                subId: id,
                masterId:masterId
            };
      setLoading(true);
            callApi("POST", "subCategoryDelete.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        showSuccess("Success!", "Sub-Category Deleted Successfully!");
                        tableCategoryShow();
          setLoading(false);

                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }


    return (
        <>
            <div>
                <div className="mobile_nav_bar">
                    <TopNavBar />
                </div>
                <div className="">
                    <Row className='webview'>
                        <div className="category-header">
                            <Col lg="8" md="8">
                                <h3 className="category-title">
                                    Subcategory Master
                                </h3>
                            </Col>
                            <Col lg="4" md="4" className="headbtn">
                                <button className="cashinbtn"
                                    onClick={siteShow}>
                                    Add Subcategory
                                </button>
                                <div className="search-bar">
                                    <img
                                        src={search}
                                        alt="search-icon"
                                        style={{ width: "22px" }}
                                    />
                                    <input type="text" placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)} />
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row className='mblview'>
                        <div className="category-header">
                            <div className='mblsitecol'>
                                <Col lg="9" md="9">
                                    <h3 className="category-title">
                                        Site Master
                                    </h3>
                                </Col>
                                <Col lg="1" md="1" className="">
                                    <button className="cashinbtn"
                                        onClick={siteShow}>
                                        Add Sub Category
                                    </button>
                                </Col>
                            </div>
                            <Col lg="2" md="2" className='flexcenter'>
                                <div className="search-bar">
                                    <img
                                        src={search}
                                        alt="search-icon"
                                        style={{ width: "22px" }}
                                    />
                                    <input type="text" placeholder="Search..." />

                                </div>
                            </Col>
                        </div>
                    </Row>
                </div>

                <div className="element-container">
    
                    {filteredData.length > 0 ? (
                        <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Master Name</th>
                                        <th>Sub-Category Name</th>
                                        <th>Status</th>
                                        <th>Created Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                            {offset + index + 1}
                                            </td>
                                            <td className='boldtd'>{item.masterName}</td>
                                            <td>
                                                <span >
                                                    {item.subName}
                                                </span>
                                            </td>
                                            <td>
                                                {item.status == "Active" && (
                                                    <button
                                                    className='more-btn '
                                                        onClick={() => handleInactive(item.id, item.status)}
                                                    >
                                                        {item.status}
                                                    </button>
                                                )}
                                                {item.status == "Inactive" && (
                                                    <button
                                                    className='more-btn '
                                                    
                                                        onClick={() => handleInactive(item.id, item.status)}
                                                    >
                                                        {item.status}

                                                    </button>
                                                )}
                                            </td>
                                            <td>{dayjs(item.create_date).format('DD-MM-YYYY')}</td>
                                            <td>
                                                <div className='webview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu
                                                            id="webdropdown">
                                                            <Dropdown.Item
                                                                onClick={() => handleEdit(item.id)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => deleteApi(item.id,item.masterId)}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>
                                                           
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                                <div className='mblview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => handleEdit(item.id)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                            // onClick={() => handleDelete(item.id)}
                                                            >
                                                                Active
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    {`${startItem} - ${endItem} of ${filteredData.length}`}
                                </div>
                                <ReactPaginate
                                    previousLabel={'<'}
                                    nextLabel={'>'}
                                    breakLabel={'...'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    activeClassName={'active-page'}
                                    pageClassName={'page-item'}
                                    previousClassName={'prev-next'}
                                    nextClassName={'prev-next'}
                                />
                            </div>
                        </div>
                    ) : (
                        <p className='nodata'>Data Not Found</p>
                    )}
                </div>
            </div>

            <Modal show={siteModal} onHide={siteClose}>
                <Modal.Header closeButton>
                    <h4 className='category-title '>Sub-Category Form</h4>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="loginform">

                            <div className="labeldiv">
                                <label className="label">Master Category*</label>
                                <Form.Select
                                    aria-label="Default select example"
                                    name="MasterId"
                                    required
                                    onChange={siteOnchange}
                                    value={state.MasterId}
                                    style={{ background: "#dce6ef !important" }}
                                    className='bg'

                                >
                                    <option value="">Select Site</option>
                                    {state.MasterOptionselect.map((categery: any) => (
                                        <option key={categery.value} value={categery.value}>
                                            {categery.label}
                                        </option>
                                    ))}

                                </Form.Select>
                            </div>
                            <div className="labeldiv">
                                <label className="label">Sub Category Name*</label>
                                <input
                                    type="text"
                                    className="form-control bg"
                                    placeholder="Enter Sub Category Name"
                                    name="SubcategoryName"
                                    minLength={2}
                                    onChange={siteOnchange}
                                    value={state.SubcategoryName}
                                    onKeyPress={(e) => {
                                        const regex = /^[A-Za-z\s]+$/;
                                        if (!regex.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    maxLength={70}
                                    required />
                            </div>
                            <div className="savenew">

                                {state.CatId ? (
                                    <>
                                        <button
                                            className="btn btn-primary modalsubbutton mt-3 mb-3"
                                            type="button"
                                            onClick={handleUpdate}
                                        >
                                            Update
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        className="btn btn-primary modalsubbutton mt-3 mb-3"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            
            {loading && (
        <div className="loader-overlay">
          <div className="loader-container">
            <Hourglass visible={true} height={50} width={50} />
          </div>
        </div>
      )}
            </>
    )
}

export default SubCategory